import BillboardDomain from './BillboardDomain';

export default BillboardDomain;
